import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';  
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { Api, ApiAuth } from 'app/domain/api';
import { ApiResponse } from 'app/domain/auth.model';
import { AgentDTO } from 'app/domain/api.model';


@Injectable({providedIn: 'root'})
export class AgentService  { 

  constructor(private http: HttpClient) { }


  private _agents = new BehaviorSubject<AgentDTO[]>([]); 
  
  get agents$(): Observable<AgentDTO[]> {    
    return this._agents.asObservable();
  }

 

  getAll(): Observable<AgentDTO[]> {
    return this.http.get<AgentDTO[]>(Api.Agents).pipe(
      map(agents => 
        // Sort logic: (a, b) comparison
        agents.sort((a, b) => {
  const snA = a?.surname ?? '';
  const snB = b?.surname ?? '';
  return snA.localeCompare(snB);
})
      ),
      tap((sorted) => {
        this._agents.next(sorted);
      })
    );
  }
private _agent: BehaviorSubject<AgentDTO | null> = new BehaviorSubject<AgentDTO | null>(null);
  
  get agent$(): Observable<AgentDTO | null> {
    return this._agent.asObservable();
  }

  get(code : string): Observable<AgentDTO> {
    return this.http.get<AgentDTO>(Api.Agent + '/get/' + code).pipe(
        tap((agent) => {
            this._agent.next(agent);
        })
    );
  } 

 

  public delete(code : String) : Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(Api.Agent + "/" + code);
  }


  public load() : Observable<AgentDTO[]> {
    return this.http.get<AgentDTO[]>(Api.Agent);
  }



  public save(dto : AgentDTO) : Observable<ApiResponse> {
    if(!dto.code)
      return this.http.post<ApiResponse>(Api.Agent, dto);
    else
      return this.http.put<ApiResponse>(Api.Agent, dto);
  }




private _agentLogged: BehaviorSubject<AgentDTO | null> = new BehaviorSubject<AgentDTO | null>(null);

  
  get agentLogged$(): Observable<AgentDTO | null> {
    return this._agentLogged.asObservable();
  }

  getLogged(): Observable<AgentDTO> {
    return this.http.get<AgentDTO>(Api.Agent + '/current').pipe(
        tap((agentLogged) => {
            this._agentLogged.next(agentLogged);
        })
    );
  } 
 
}
